import React from 'react';
import './App.css';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import TransitionWave from './components/TransitionWave';

function App() {
  return (
    <div className="app-container">
      <HeroSection />
      <TransitionWave />
      <ServicesSection />
    </div>
  );
}

export default App;
